import { render, staticRenderFns } from "./component-status-text.vue?vue&type=template&id=49ddccad"
import script from "./component-status-text.vue?vue&type=script&lang=js"
export * from "./component-status-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports